module.exports = __webpack_public_path__ + "img/bv-android-apk.b49e3292.png";